import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import {
  Row,
  Col,
} from 'react-bootstrap';

import ExportPayPeriod from './ExportPayPeriod';
import FinalizePayPeriod from './FinalizePayPeriod';
import ReopenPayPeriod from './ReopenPayPeriod';

const propTypes = exact({
  payPeriod: PropTypes.object.isRequired,
  isPayPeriodClosed: PropTypes.bool.isRequired,
  isPayPeriodFinalized: PropTypes.bool.isRequired,
});

const UnopenedPayPeriod = (props) => {
  const {
    payPeriod,
    isPayPeriodClosed,
    isPayPeriodFinalized,
  } = props;

  const { state } = payPeriod;

  return (
    <div>
      <h3>
        The pay period is {state}
      </h3>
      <Row>
        <Col xs={6}>
          <ExportPayPeriod
            isPayPeriodClosed={isPayPeriodClosed}
            payPeriod={payPeriod}
          />
          <FinalizePayPeriod
            isPayPeriodFinalized={isPayPeriodFinalized}
            payPeriod={payPeriod}
          />
        </Col>
      </Row>
      {isPayPeriodClosed && !isPayPeriodFinalized && (
        <React.Fragment>
          <hr />
          <Row style={{ paddingTop: '20px' }}>
            <Col xs={6}>
              <ReopenPayPeriod
                isPayPeriodClosed={isPayPeriodClosed}
                isPayPeriodFinalized={isPayPeriodFinalized}
                payPeriod={payPeriod}
              />
            </Col>
          </Row>
        </React.Fragment>
      )}
    </div>
  );
};

UnopenedPayPeriod.propTypes = propTypes;

export default UnopenedPayPeriod;
